import Head from 'next/head'

import { Header } from 'components/Header'
import { TNS } from 'components/TNS'
import { isNavigator, isWebview } from 'utils/browser'

const title = 'Persyaratan Layanan'

function TnsPageHeader() {
  let isOpenedOnWebview = isNavigator ? isWebview() : true

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>

      {isOpenedOnWebview ? null : (
        <Header
          title={title}
          hasBackButton
          hasOrnament
          variant="primary"
          bordered={false}
          iconLeftSrc="/icon/arrow-left-white.svg"
        />
      )}
    </>
  )
}

export default function TnsPage() {
  return (
    <div className="pt-4 px-4 py-14 leading-loose">
      <p className="font-semibold">Terakhir diperbarui: 01/03/2025</p>
      <br />
      <TNS />
    </div>
  )
}

TnsPage.layoutOpts = {
  hasBottomNav: false,
  hasHeader: true,
  header: TnsPageHeader,
}
